<p-dialog
    header="{{ title }}"
    [modal]="true"
    [(visible)]="visible"
    [breakpoints]="{ '960px': '450px', '640px': '350px' }"
    [style]="{
        width: isDeletedPopup
            ? '25vw'
            : isVersionConfirmationPopup
            ? '25vw'
            : '40vw'
    }"
    closable="false"
    (onHide)="onClosePopup($event)"
    draggable="false"
    [resizable]="false"
>
    <ng-content></ng-content>
    <div class="button-group">
        <p-button
            (onClick)="onClosePopup($event)"
            title=""
            class="secondary-btn"
            [style.visibility]="showCancelBtn ? 'visible' : 'hidden'"
        >
            {{ cancelButtonText }}</p-button
        >
        <p-button
            (onClick)="onSubmit()"
            [loading]="submitLoading"
            title=""
            *ngIf="showSubmitBtn"
            [disabled]="submitDisabled"
        >
            {{ submitButtonText ? submitButtonText : "Submit" }}</p-button
        >
    </div>
</p-dialog>
